"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconLock = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M59 33.45h-4V24a20 20 0 0 0-40 0v9.47h-4a4 4 0 0 0-4 4.03V61a4 4 0 0 0 4.05 4H59a4 4 0 0 0 4-4V37.5a4 4 0 0 0-4-4.05zM21.33 24a13.67 13.67 0 1 1 27.34 0v9.47H21.33z"
  })),
  height: undefined,
  width: undefined
});
IconLock.displayName = 'IconLock';
var _default = IconLock;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/lock.js
// module id = 573
// module chunks = 0